import { ComponentType, lazy } from 'react';

export function getFlagByCode(code: string) {
  return lazy(
    async () =>
      await import('../flags').then((m) => ({
        default: (m as Record<string, ComponentType>)[`DawnFlag${code}`],
      })),
  );
}
